<script lang="ts">
    import {onMount} from "svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";
    import PortalView from "../../../component/common/Portal/PortalView.svelte";
    import DialogView from "../../../component/common/Dialog/DialogView.svelte";
    import LoadingContentView from "../../../component/common/Loading/LoadingContentView.svelte";
    import ArraySlotView from "../../../component/common/Value/ArraySlotView.svelte";
    import AddButtonView from "../../../component/common/Button/AddButtonView.svelte";
    import SpaceAccessTokenRowView from "./SpaceAccessTokenRowView.svelte";
    import SpaceAccessTokenEditDialogView from "./SpaceAccessTokenEditDialogView.svelte";
    import TipsMessageAreaView from "../../../component/common/Message/TipsMessageAreaView.svelte";


    export let isShow = false;
    export let space;

    let spaceAccessTokens = null;

    let isLoading = false;
    let editData = null;

    onMount(() => {
    });

    function onShow() {
        loadData();

    }

    function loadData() {
        const paramMap = {};
        paramMap['space_id'] = space.id;
        paramMap['visible_access_token'] = undefined;

        const url = UrlUtil.createApiUrl("space_access_token", paramMap);

        isLoading = true;
        HttpRequestUtil.getRequest(url, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];
            spaceAccessTokens = body['space_access_tokens'];


        });
    }

    function onEdit(event) {
        const spaceAccessToken = event.detail.spaceAccessToken;
        console.log({spaceAccessToken});
        editData = {...spaceAccessToken};
    }

    function onClickAdd() {
        editData = {
            space_id: space.id
        };
    }


</script>

<PortalView>
    <DialogView title="スペースアクセストークン設定" isShow={isShow} on:show={onShow} on:close>
        <div class="space-access-token-dialog-content">
            <LoadingContentView isLoading={isLoading}>
                <ArraySlotView array={spaceAccessTokens}>
                    <table>
                        <thead>
                        <tr>
                            <th></th>
                            <th>名前</th>
                            <th class="type">タイプ</th>
                            <th>アクセストークン</th>
                            <th class="expire-at">有効期限</th>
                            <th>使用回数</th>
                            <th>前回使用時</th>
                            <th>作成更新情報</th>
                        </tr>

                        </thead>
                        <tbody>
                        {#each spaceAccessTokens as spaceAccessToken}
                            <SpaceAccessTokenRowView spaceAccessToken={spaceAccessToken} on:edit={onEdit}/>
                        {/each}
                        </tbody>
                    </table>


                </ArraySlotView>

                <div class="button-area">
                    <AddButtonView on:click={onClickAdd}/>
                </div>
                <div>
                    <TipsMessageAreaView>
                        スペースアクセストークンを使うと各種情報を API で取得することができます。
                        例えば「/api/app?space_id=【スペースID】&include_latest_binary&access_token=【アクセストークン】」でアプリ一覧が取得できます。
                        それ以外の情報を取得したい場合は、Chrome Developer Tool を使って、アクセスしている取得系APIだとすべてデータがとれるため、調べてみてください。
                    </TipsMessageAreaView>
                </div>


            </LoadingContentView>


        </div>

    </DialogView>
</PortalView>

<SpaceAccessTokenEditDialogView
        space={space}
        editData={editData}
        on:update={loadData}
        on:close={()=>{
            editData = null;
        }}

/>

<style lang="scss">
    .space-access-token-dialog-content {
        min-height: 300px;

        table {
            thead {
                th {
                    &.type {
                        min-width: 100px;
                    }

                    &.expire-at {
                        min-width: 150px;
                    }
                }
            }
        }

        .button-area {
            margin-top: 60px;
        }

    }
</style>